import clsx from 'clsx';
import { ComponentProps, PropsWithChildren } from 'react';
import styles from './clickable.module.scss';

export const Clickable = ({ children, ...props }: PropsWithChildren<ComponentProps<'button'>>) => {
  const inputsDisabled = props.disabled;
  return (
    <button
      {...props}
      type='button'
      className={clsx(styles.clickable, props.className)}
      disabled={inputsDisabled}
    >
      {children}
    </button>
  );
};
